/**
 * 此处可直接引用自己项目封装好的 axios 配合后端联调
 */
import request from '@/utils/request'
import { ouchnSource } from '../../../service'


// import request from "@/api/axios.js"       //调用项目封装的axios

// 获取验证图片  以及token
export function reqGet() {
  return request({
    method:"get" ,
    url: ouchnSource+'/blockCaptcha/getBlockPuzzle'
  })
}

// 滑动或者点选验证
export function reqCheck(data) {
  return request({
    method:"post",
    url:ouchnSource+ '/blockCaptcha/check',
    data: data
  })
}

